import { useCallback, useState } from "react";

export const useBoolean = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const on = useCallback(() => {
    setValue(true);
  }, []);

  const off = useCallback(() => {
    setValue(false);
  }, []);

  return [value, on, off];
};